import { makeAutoObservable, observable, toJS } from "mobx";
import type { RgPlot } from "./RgCorePackage";
import type { PlotData } from "@project-rouge/rg-core";
import { DefaultPlot, RgCreate } from "@project-rouge/rg-core";
import { Building } from "./Building";
import type { Zone } from "./Zone";
import { Dataset } from "src/constants/Dataset";

interface PlotConfig {
  rgPlot?: RgPlot;
}

export class Plot {
  id: string;
  children: Building[] = [];
  readonly data: PlotData;
  parent: Zone | undefined;
  constructor(config?: PlotConfig) {
    this.id = config?.rgPlot?.uuid ?? "";
    config?.rgPlot?.children.forEach((rgBuilding) =>
      this.addBuilding(new Building({ rgBuilding }))
    );
    this.data = config?.rgPlot?.data ?? CreateDefaultData();
    makeAutoObservable(this, {
      data: observable.ref,
    });
  }

  get rgPlot(): RgPlot {
    // @todo - use dataset from world or let user choose
    const dataset = Dataset;
    const rgPlot = RgCreate<RgPlot>(DefaultPlot, dataset.rvData);
    rgPlot.uuid = this.id;
    rgPlot.data = toJS(this.data);
    rgPlot.children = this.buildings.map((building) => {
      const rgBuilding = building.rgBuilding;
      rgBuilding.parent = rgPlot;
      return rgBuilding;
    });
    return rgPlot;
  }

  get buildings(): Building[] {
    return this.children;
  }
  addBuilding(building: Building): void {
    if (this.children.includes(building)) return;
    building.parent = this;
    this.children.push(building);
  }
  removeBuilding(building: Building | Building[]): void {
    const buildingsSet = new Set(Array.isArray(building) ? building : [building]);
    for (const building of buildingsSet) {
      const childIndex = this.children.findIndex((child) => child === building);
      if (childIndex < 0) continue;
      const child = this.children[childIndex];
      child.parent = undefined;
      this.children.splice(childIndex, 1);
    }
  }
  setId(id: string): void {
    this.id = id;
  }
}
function CreateDefaultData(): PlotData {
  return {
    polygon: [],
    zonePolyIndex: 0,
  };
}
